import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTE_PATH } from 'constants/routePath';
import { DEFAULT_PAGE_SIZE } from 'constants/page';

type TProps = {
  patientId?: string | undefined;
  courseId?: string | undefined;
  courseInfoId?: string | undefined;
  chartRound?: string | undefined;
  studentUserId?: string | undefined;
};

const useGoBack = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const firstPath = location.pathname.split('/')[1];

  return ({
    patientId,
    courseId,
    courseInfoId,
    chartRound,
    studentUserId,
  }: TProps = {}) => {
    switch (firstPath) {
      case 'notice':
        navigate(ROUTE_PATH.common.NOTICE);
        break;
      case 'practice':
        navigate(ROUTE_PATH.student.PRACTICE_CHART);
        break;
      case 'evaluation': {
        // 접근 루트에 따라 이동
        const route = sessionStorage.getItem('route');
        navigate(
          // 대상자관리 > 상세
          route === 'patient'
            ? patientId && courseInfoId && chartRound
              ? `${ROUTE_PATH.student.PATIENT}/${patientId}?courseInfoId=${courseInfoId}&chartRound=${chartRound}`
              : ROUTE_PATH.student.PATIENT_MANAGEMENT
            : // 차트 > 실습용 차트
            route === 'chart'
            ? courseInfoId && chartRound
              ? `${ROUTE_PATH.student.EVALUATION_CHART}?courseInfoId=${courseInfoId}&chartRound=${chartRound}`
              : ROUTE_PATH.student.EVALUATION_CHART
            : // 종합평가
            route === 'report'
            ? courseInfoId && chartRound
              ? `${ROUTE_PATH.student.SCORE_REPORT}?courseInfoId=${courseInfoId}&chartRound=${chartRound}`
              : ROUTE_PATH.student.SCORE_REPORT
            : '/'
        );
        sessionStorage.removeItem('route');
        break;
      }
      case 'feedback': {
        // 접근 루트에 따라 이동
        const route = sessionStorage.getItem('route');
        const page = sessionStorage.getItem('page');
        navigate(
          // 학생 > 상세
          route === 'student'
            ? studentUserId && courseInfoId && chartRound
              ? `${
                  ROUTE_PATH.professor.STUDENT
                }/${studentUserId}?courseInfoId=${courseInfoId}&chartRound=${chartRound}${
                  page ? `&size=${DEFAULT_PAGE_SIZE}&page=${page}` : ''
                }`
              : ROUTE_PATH.professor.STUDENT
            : // 실습평가 > 실습평가
            route === 'assessment'
            ? courseId && courseInfoId && chartRound
              ? `${
                  ROUTE_PATH.professor.CLINICAL_PRACTICE
                }?courseId=${courseId}&courseInfoId=${courseInfoId}&chartRound=${chartRound}${
                  page ? `&size=${DEFAULT_PAGE_SIZE}&page=${page}` : ''
                }`
              : ROUTE_PATH.professor.CLINICAL_PRACTICE
            : // 통계 > 학생 개별 조회
            route === 'statistics'
            ? courseId && courseInfoId && chartRound && studentUserId
              ? `${ROUTE_PATH.professor.STATISTICS}?courseId=${courseId}&courseInfoId=${courseInfoId}&chartRound=${chartRound}&studentUserId=${studentUserId}`
              : ROUTE_PATH.professor.STATISTICS
            : '/'
        );
        sessionStorage.removeItem('route');
        sessionStorage.removeItem('page');
        break;
      }
      default:
        navigate('/');
        break;
    }
  };
};

export default useGoBack;
